module.exports = __webpack_public_path__ + "img/photo_2022-10-23_14-59-24.fd22a248.jpg";